import React, {useState} from "react";
import styled from "styled-components";
import {Box} from "@mui/material";
import {PureButton} from "components/Button";
import nav from "assets/images/icons/nav.svg";
import {useTranslation} from "react-i18next";
import navClose from "assets/images/icons/nav_close.svg";
import {media} from "assets/css/media";

const MenuToggle = styled(PureButton)`
	padding-top: 8px;
	margin-right: 20px;

	img {
		vertical-align: middle;
		width: 36px;
		height: 36px;
	}
`;

const Menu = styled.ul`
	list-style: none;
	padding: 18px 24px;
	width: 325px;
	position: fixed;
	top: calc(56px + 64px);
	height: 100%;
	left: 0;
	z-index: 8;
	background-color: ${({theme}) => theme.global.header_background};
	transform: translateX(-100%);
	transition: 0.25s;

	&.open {
		transform: unset;
	}

	li > a {
		padding-top: 16px;
		padding-bottom: 16px;
		display: block;
	}

	@media (max-width: ${media.mobile}) {
		top: 56px;
	}
`;

const DropdownLink = styled.a`
	color: #fff;
	opacity: 0.75;
	font-weight: 500;
	transition: 0.2s color ease-in-out;

	&:hover,
	&:active,
	&:focus {
		color: ${({theme}) => theme.global.header_hover_color};
	}

	@media (max-width: ${media.large_desktop}) {
		font-size: 14px;
	}
`;

const LINKS = [
	{title: "header.dropdown.originals", href: ""},
	{title: "header.dropdown.news", href: ""},
	{title: "header.dropdown.matches", href: ""},
	{title: "header.dropdown.live", href: ""},
	{title: "header.dropdown.women", href: ""},
	{title: "header.dropdown.archive", href: ""},
	{title: "header.dropdown.fifa", href: "https://www.fifa.com/"},
];

export const DropdownMenu: React.FC = () => {
	const {t} = useTranslation();
	const [isOpen, setIsOpen] = useState(false);
	const openMenuClass = isOpen ? "open" : "";

	const toggleMenu = () => setIsOpen(!isOpen);

	return (
		<Box
			sx={{
				position: "relative",
			}}>
			<MenuToggle onClick={toggleMenu}>
				{isOpen ? <img src={navClose} alt="Close" /> : <img src={nav} alt="Open" />}
			</MenuToggle>
			<Menu className={openMenuClass}>
				{LINKS.map((link) => (
					<li key={link.title}>
						<DropdownLink href={link.href}>{t(link.title)}</DropdownLink>
					</li>
				))}
			</Menu>
		</Box>
	);
};
